import React, { useEffect } from 'react';
import config from '../../config';

const GA_MEASUREMENT_ID = config.GA_MEASUREMENT_ID;

export const trackEvent = (eventName, params = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, params);
  } else {
    console.warn(`GA4: Event "${eventName}" not tracked. gtag not initialized.`);
  }
};

const GoogleAnalytics = ({ children }) => {
  useEffect(() => {
    // 1. Initialize Consent Mode (v2 Default: Denied)
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;

    // Check for previous consent in localStorage
    const savedConsent = localStorage.getItem('zap_analytics_consent');
    const initialConsent = savedConsent === 'granted' ? 'granted' : 'denied';

    gtag('consent', 'default', {
      'analytics_storage': initialConsent,
      'ad_storage': initialConsent,
      'ad_user_data': initialConsent,
      'ad_personalization': initialConsent,
      'wait_for_update': 500
    });

    // 2. Load GA4 Script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID, {
      page_path: window.location.pathname,
      // Disable default page view to track manually for SPA
      send_page_view: false 
    });

    // 3. Cleanup on unmount
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  // Track page views on route/pathname change
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: window.location.pathname,
        page_title: document.title
      });
    }
  }, [window.location.pathname]);

  return <>{children}</>;
};

export default GoogleAnalytics;
